import React from "react"
import { Grid, Typography } from "@material-ui/core"
import AwsExportConfig from "./aws-exports"
import { Auth, Amplify } from "aws-amplify"
import OfferingsContent from "./content/offerings"

Amplify.configure(AwsExportConfig());

class OfferingsPage extends React.Component {
  componentDidMount() {
    const getUser = async () => {
      try {
        const authenticatedUser = await Auth.currentAuthenticatedUser();
        console.log("Pages: ", authenticatedUser);
      } catch {
        console.log("The user isn't signed in");

        setTimeout(() => {
          Auth.federatedSignIn({ customProvider: "SAIC" });
        }, 2000);
      }
    };

    getUser();
  }

  render() {
    return (
      <main className="faqPageContainer">
        <Grid container xs={12} sm={12} className="fadePanel">
          <Grid item xs={12} sm={12}>
            <Typography variant="h5" className="pageTitleSection">
              Offerings
            </Typography>
            <div className="spacer" />
          </Grid>

          <Grid item xs={12} sm={12}>
            <OfferingsContent />
          </Grid>
        </Grid>
      </main>
    );
  }
}

export default OfferingsPage;
